var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getRawImageObject = function (containerKey, images, includeContext) {
    var _a;
    if (images === void 0) { images = []; }
    if (includeContext === void 0) { includeContext = false; }
    var imageObjects = images
        .filter(function (_a) {
        var url = _a.url;
        return !!url;
    })
        .map(function (image) { return getSingleImageObject(image, includeContext); });
    return imageObjects.length
        ? (_a = {},
            _a[containerKey] = imageObjects.length === 1
                ? __assign({}, imageObjects[0]) : imageObjects,
            _a) : {};
};
export var getSingleImageObject = function (image, includeContext) {
    if (includeContext === void 0) { includeContext = false; }
    var url = image.url, width = image.width, height = image.height, alt = image.alt, name = image.name;
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (includeContext ? { '@context': 'https://schema.org/' } : {})), { '@type': 'ImageObject' }), (height ? { height: height } : {})), (width ? { width: width } : {})), (alt ? { alt: alt } : {})), (name ? { name: name } : {})), { url: url });
};
